import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { RenderableFieldInterface } from '../../tokens-and-interfaces';

@Component({
  selector: 'crm-renderer-selector',
  template: '<ng-container></ng-container>',

  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RendererSelectorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() handler: RenderableFieldInterface | null = null;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this.handler?.render(this.viewContainerRef);
  }

  ngOnChanges(): void {
    this.handler?.render(this.viewContainerRef);
  }

  ngOnDestroy(): void {
    this.handler = null;
  }
}
